import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import "./App.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Login from "./pages/Login";
import Dashboard from "./components/admin/Dashboard";
import Org from "./components/admin/Org";
import Role from "./components/admin/Role";
import Doctors from "./components/admin/Doctors";
// import DoctorAppointments from "./components/doctor/Appointment";
import Patient from "./components/doctor/Patients";
import DoctorDashboard from "./components/doctor/DoctorDashboard";
import PatientAppointment from "./components/patient/PatientDashboard";
import PatientReports from "./components/patient/Reports";
import MedicineComponent from "./components/patient/Medication";
import PatientRecord from "./components/patient/Record";

import AppLayout from "./components/Layout/AppLayout";
import VideoCall from "./components/patient/VideoCall";
import RegisterPatient from "./pages/RegisterPatient";
import DoctorVideoCall from "./components/doctor/DoctorCall";
import MyAppointments from "./components/patient/Appointments";
import DoctorBooking from "./components/patient/BookAppointment";
import LabRadiologyMaster from "./components/admin/LabRad";
import MedicineMaster from "./components/admin/MedicineMaster";
import ProtectedRoute from "./route/ProtectedRoute";
import { useSelector } from "react-redux";
import ReceptionistDashboard from "./components/receptionist/Dashboard";
import BookingDashboard from "./components/receptionist/Booking";

// ✅ Slide animation (panel style)
const pageVariants = {
  initial: { opacity: 0, x: "100%" }, // start off screen right
  in: { opacity: 1, x: 0 }, // slide to center
  out: { opacity: 0, x: "-100%" }, // slide out left
};

const pageTransition = { type: "tween", ease: "easeInOut", duration: 0.6 };

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Navigate to="/login" />} />

        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route
          path="/register"
          element={
            <motion.div
              style={{ height: "100vh", overflow: "hidden" }}
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <RegisterPatient />
            </motion.div>
          }
        />
        <Route element={<ProtectedRoute />}>
          {/* ✅ Routes without AppLayout */}
          <Route path="/call" element={<VideoCall />} />
          <Route path="/video-call" element={<DoctorVideoCall />} />

          {/* ✅ Routes with AppLayout */}
          <Route element={<AppLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/org" element={<Org />} />
            <Route path="/role" element={<Role />} />
            <Route path="/doctors" element={<Doctors />} />
            {/* <Route path="/appointments" element={<DoctorAppointments />} /> */}
            <Route path="/appointments" element={<Patient />} />
            <Route path="/doc-dashboard" element={<DoctorDashboard />} />
            <Route path="/patient-dashboard" element={<PatientAppointment />} />
            <Route path="/patient-reports" element={<PatientReports />} />
            <Route path="/prescriptions" element={<MedicineComponent />} />
            <Route path="/patient-records" element={<PatientRecord />} />
            <Route path="/patient-appointment" element={<MyAppointments />} />
            <Route path="/book-appointment" element={<DoctorBooking />} />
            <Route path="/lab" element={<LabRadiologyMaster />} />
            <Route path="/medicine-master" element={<MedicineMaster />} />
            <Route path="/recp-dashboard" element={<ReceptionistDashboard />} />
            <Route path="/booking" element={<BookingDashboard />} />
          </Route>
        </Route>
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  const { data: logoutData } = useSelector((state) => state.logout);

  return (
    <BrowserRouter>
      <ToastContainer position="bottom-right" autoClose={3000} />
      <AnimatedRoutes key={logoutData?.status ? "loggedout" : "active"} />
    </BrowserRouter>
  );
}

export default App;
